/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
export default {
  name: 'ViewCard',
  data: function data() {
    return {};
  },
  created: function created() {}
};